<p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
<div class="card bg-light">
    <div class="card-body">
        <div class="form-row">
            <label for="txtAgency" class="col-sm-1 col-form-label prd-label">Agency</label>
            <input id="txtAgency" [(ngModel)]='agent.name' class="form-control col-sm-3" (change)='dataChange()' maxlength="80">  &nbsp; &nbsp;
            <!-- <button hidden class="btn btn-sm btn-secondary col-sm-1" title="Use this button to search your database for a matching Agency"> Find Agency </button>-->
            <button (click)="getAgencyList()" title="Search your database for a matching Agency" class="btn btn-info btn-sm">Find Agency</button>
            <button (click)="getLastAgency()" title="Get the LAST agency saved by you." class="offset-1 btn btn-outline-secondary btn-sm" 
                *ngIf="bHasPrevAgent">Get Last Agency</button>
            <label for="txtPhone" class="col-sm-1 col-form-label prd-label">Phone</label>
            <input id="txtPhone" [(ngModel)]='agent.phone' title="Enter main Agency telephone #" class="form-control col-sm-2" (change)='dataChange()'>
        </div>
        <div class="card" style="margin: 10px;" *ngIf="agencyList?.length > 0">
            <button (click)="clearAgencyList()" class="btn btn-sm btn-info">Clear List</button>
            <hr />
            <p-table [value]="agencyList" [scrollable]="true" scrollHeight="520px" styleClass="p-datatable-striped p-datatable-bordered" >
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of cols; let i = index" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon *ngIf="i>0" field="{{col.field}}"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-agency>
                    <tr style="font-size: small">
                        <td>
                            <button class="btn btn-link" (click)="agencySelected(agency)"> Select </button>
                        </td>
                        <td>{{ agency.name }}</td>
                        <td>{{ agency.strAddr}}</td>
                        <td>{{ agency.city }}</td>
                        <td>{{ agency.state }}</td>
                        <td>{{ agency.phone}}</td>
                        <td>{{ agency.email }}</td>
                    </tr>
                </ng-template>
                <ng-template *ngIf="agencyList" pTemplate="summary">
                    <div class="row">
                        <div class="col-md-2 offset-1" style="text-align: left;"># of matches: {{ agencyList.length }}</div>
                    </div>
                </ng-template>
            </p-table>
            <br />
        </div>
        <br />
        <div *ngIf="!agencyList?.length">  <!-- hide if showing list from lookup-->
            <div class="form-row">
                <label for="txtContact" class="col-sm-1 col-form-label prd-label">Contact</label>
                <input id="txtContact" [(ngModel)]='agent.contact' class="form-control col-sm-3" (change)='dataChange()' maxlength="80">
            <!-- <label for="txtNameFirst" class="col-sm-1 col-form-label prd-label">First Name</label>
                <input id="txtNameFirst" class="form-control col-sm-2">
                <label for="txtNameMI" class="col-sm-1 col-form-label prd-label">Middle Initial</label>
                <input id="txtNameMI" class="form-control col-sm-2">  -->
            </div>
            <br/>
            <div class="form-row">
                <label for="txtEmail" class="col-sm-1 col-form-label prd-label">E-mail</label>
                <input id="txtEmail" [(ngModel)]='agent.email' class="form-control col-sm-3" (change)='dataChange()'>
                <label for="txtAltPhone" class="col-sm-1 col-form-label prd-label">Alt Phone</label>
                <input id="txtAltPhone" [(ngModel)]='agent.altPhone' class="form-control col-sm-2" (change)='dataChange()'>
            <!-- <label for="txtAltPhone" class="col-sm-1 col-form-label prd-label">Alt Phone</label>
                <input id="txtAltPhone" class="form-control col-sm-1 prd-small"> -->
                <label for="txtFax" class="col-sm-1 col-form-label prd-label">Fax #</label>
                <input id="txtFax" [(ngModel)]='agent.fax' class="form-control col-sm-1 prd-small" (change)='dataChange()'>
            </div>
            <br />
            <div class="form-row">
                <label for="txtAddress" class="col-sm-1 col-form-label prd-label">Address</label>
                <input id="txtAddress" [(ngModel)]='agent.strAddr' class="form-control col-sm-3" (change)='dataChange()' maxlength="100">
                <label for="txtCity" class="col-sm-1 col-form-label prd-label">City</label>
                <input id="txtCity" [(ngModel)]='agent.city' class="form-control col-sm-2" (change)='dataChange()' maxlength="50">
                <label for="txtState" class="col-sm-1 col-form-label prd-label">State</label>
                <input id="txtState" [(ngModel)]='agent.state' class="form-control col-sm-1" (change)='dataChange()'>
                <label for="txtZip" class="col-sm-1 col-form-label prd-label">Zip</label>
                <input id="txtZip" [(ngModel)]='agent.zip' class="form-control col-sm-1" (change)='dataChange()'>
            </div>
            <br />
            <div class="form-row">
                <label for="txtComment" class="col-sm-1 col-form-label prd-label">Comment</label>
                <textarea id="txtComment" [(ngModel)]='agent.comment' class="form-control col-sm-8" (change)='dataChange()'> </textarea>
            </div>
            <br />
            <div class="form-row">
                <label for="chkAuthSig" class="col-sm-1 col-form-label prd-label">Original Authorizing Signature</label>
                <input id="chkAuthSig" type="checkbox" [(ngModel)]='agent.sign' class="form-control col-sm-2" (change)='dataChange()'>
                <label for="chkSigNotNeeded" class="col-sm-2 offset-1 col-form-label prd-label">Signature not Needed</label>
                <input id="chkSigNotNeeded" type="checkbox" [(ngModel)]='agent.signNoNeed' class="form-control col-sm-1" (change)='dataChange()'>
            </div>
        </div>
    </div>
</div>


